import React from 'react'
import { useWindowWidth } from '@react-hook/window-size'
import styles from './NigerianBirds.module.css'



const NigerianBirds = () => {


    const width = useWindowWidth()
    console.log(width)

    return (
      <div className={styles.featuresContainer} >
            <div className={styles.items}>
                <ul className={styles.autoGrid}>

            <li className={styles.listItem}>
                        <img  className={styles.imgThumbnail} src="https://res.cloudinary.com/wabis/image/upload/v1762936759/wfuensaufixogm3iwgsh_v8gtvh.jpg" alt="White-throated Bee-eater" />
                </li>

                {width > 1300 && (
                     <li className={styles.listItem}>
                     <img  className={styles.imgThumbnail} src="https://res.cloudinary.com/wabis/image/upload/v1762936759/wfuensaufixogm3iwgsh_v8gtvh.jpg" alt="White-throated Bee-eater" />
                    </li>
                )}


                    <li className={styles.listItem}>
                        <div style={{marginTop: '50px'}}>
                            <ul style={{padding: '30px'}}>
                                <h2>Explore the Diversity and Distribution of Nigeria’s Birds</h2>
                                <li><p style={{color: '#fff'}}> Discover the extraordinary range of birdlife found across Nigeria. Each species account provides clear identification details, notes on habitat preference, and mapped distribution within the country. </p></li>
                                {/* <li><p>Relatively little ecological field research is carried out in West Africa because of lack of infrastructure and logistical difficulties. APLORI aims to help address these issues <strong style={{color: '#3e6947'}}>  by providing a well-run field station where it is possible to carry out research relatively easily </strong> in a tropical savannah environment.</p></li>
                                 */}
                                <li>
                                    <a  className={styles.button} href="/birds">&nbsp;&nbsp; Explore All Species &nbsp;&nbsp;&nbsp; <i className="fas fa-arrow-right"></i>&nbsp;&nbsp;</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    
                


                </ul>
               
            </div>


        </div>
    )
}

export default NigerianBirds
